import { render, staticRenderFns } from "./app-lang-switcher.vue?vue&type=template&id=305a8572&scoped=true&"
import script from "./app-lang-switcher.vue?vue&type=script&lang=js&"
export * from "./app-lang-switcher.vue?vue&type=script&lang=js&"
import style0 from "./app-lang-switcher.vue?vue&type=style&index=0&id=305a8572&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305a8572",
  null
  
)

export default component.exports